import * as React from 'react';
import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import { Modal } from '@fluentui/react/lib/Modal';
import {
    closeBoardEditorDialog,
    isBoardEditorOpen,
    getLoadState,
    BoardEditorLoadState,
} from '../viewstate';
import BoardEditorForm from './BoardEditorForm';
import BoardEditorSaving from './BoardEditorSaving';
import BoardEditorError from './BoardEditorError';

export default observer(function BoardEditorDialog() {
    const loadState = getLoadState();
    const isError = loadState == BoardEditorLoadState.Error;
    return (
        <Modal
            containerClassName={isError ? styles.boardErrorDialog : styles.boardEdiorDialog}
            isOpen={isBoardEditorOpen()}
            onDismiss={closeBoardEditorDialog}
            isBlocking={false}>
            {loadState === BoardEditorLoadState.Idle ? (
                <BoardEditorForm />
            ) : isError ? (
                <BoardEditorError />
            ) : (
                <BoardEditorSaving />
            )}
        </Modal>
    );
});
